import { v4 as uuidv4 } from "uuid";
import { create } from "zustand";
import type { DrawerItem, DrawerPropsMap, DrawerState } from "../types/drawer.types";
import type { DrawerKey } from "../lib/constants/drawer.constants";

export const useDrawerStore = create<DrawerState>((set, get) => ({
  drawers: [],
  topDrawer: null,

  openDrawer: <K extends DrawerKey>(key: K, props: DrawerPropsMap[K]) => {
    const id = uuidv4();
    const drawer = { id, key, props } as DrawerItem; 

    set((state) => ({
      drawers: [...state.drawers, drawer],
      topDrawer: drawer,
    }));
    return id;
  },

  closeDrawer: (id) => {
    const newDrawers = get().drawers.filter((m: DrawerItem) => m.id !== id);
    set({
      drawers: newDrawers,
      topDrawer: newDrawers[newDrawers.length - 1] || null,
    });
  },

  closeDrawersByKey: (key) => {
    const newDrawers = get().drawers.filter((m: DrawerItem) => m.key !== key);
    set({
      drawers: newDrawers,
      topDrawer: newDrawers[newDrawers.length - 1] || null,
    });
  },

  clearDrawer: () => 
    set(() => ({ 
      drawers: [], 
      topDrawer: null
    })),
}));